import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {JobLineItems} from '../models/line.items/jobLineItems.model';
import {LineItem} from '../models/line.items/lineItem.model';

@Injectable({
  providedIn: 'root'
})
export class LineItemsService {

  constructor(private http: HttpClient) {
  }

  private LINE_ITEMS_URL: string = environment.BASE_URL + 'job';


  public getLineItems(id: string): Observable<JobLineItems> {
    return this.http.get<JobLineItems>(`${this.LINE_ITEMS_URL}/${id}/line/items`);
  }

  public updateLineItems(id: string, lineItems: LineItem[]): Observable<JobLineItems> {
    const patch = {
      lineItems,
      replace: false,
    };
    return this.http.patch<JobLineItems>(`${this.LINE_ITEMS_URL}/${id}/line/items`, patch);
  }
}
